import React from 'react';

import { Head as SEO } from '@landing/components';
import Header from 'components/Header';
import { Main } from 'components/UI';
import Intro from 'features/form/Intro';
import CallToAction from 'features/CallToAction';
import SocialMedia from 'features/SocialMedia';
import Footer from 'components/Footer';
import data from './data.json';

export default function TraineeForm() {
  return (
    <>
      <Header />
      <Main>
        <Intro {...data.intro} />
        <CallToAction {...data.callToAction} />
        <SocialMedia {...data.socialMedia} />
      </Main>
      <Footer />
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
